import Navigation from "./navigation";
import React from "react";
import './App.css';
import { AppModalHost } from "./components/AppModal/AppModal";
import GlobalTooltip from "./components/ToolTip/GlobalTooltip";
import GlobalSubmitGuard from "./components/GlobalSubmitGuard/GlobalSubmitGuard";
import AutoLogout from "./AutoLogout";
import { useState, useEffect } from 'react';
import WebService from "./utility/WebService";

const App = () => {

  useEffect(() => {
    //document.title = "Dynamic Title Example";
    getCompanyDetail();
   
  }, []);

  const getCompanyDetail = () => {
    WebService.getAPI({
      action: `/CompanyMaster/CompanyDetail`,
    })
      .then((res: any) => {
        if(res){
          if(res.short_name	){
            document.title = res.short_name	;
          const newLink = document.createElement('link');
          newLink.rel = 'icon';
          newLink.href = res.image_path	;
          document.head.appendChild(newLink);
          }
        }
      })
      .catch((e) => {
        //
      });
  };

  return (
    <>

      <AppModalHost />
      <GlobalTooltip />
      <GlobalSubmitGuard />
      <AutoLogout />
      <Navigation />
    </>
  )
}

export default App;
